import React from 'react';
import {
    Card,
    FormLayout,
    Checkbox,
    TextField
} from '@shopify/polaris';

export function TagProductsOnSaleSettings(props) {

    function onSaleTagChange(value) {

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.onSaleTag = value;
        props.onSettingsChange(newSettings);
    }

    function notOnSaleTagChange(value) {

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.notOnSaleTag = value;
        props.onSettingsChange(newSettings);
    }

    function priceMustBeLowerThanCompareAtPriceChange(value) {

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.priceMustBeLowerThanCompareAtPrice = value;
        props.onSettingsChange(newSettings);
    }

    return (
        <React.Fragment>
            <Card.Section title="Options">
                <FormLayout>
                    <TextField
                        value={props.settings.onSaleTag}
                        label="On Sale Tag"
                        placeholder="(Required) Example: on-sale"
                        error={props.settingsErrors["onSaleTag"]}
                        onChange={onSaleTagChange}
                        helpText={
                            <span>
                                The tag to apply to products that are considered on sale.
                            </span>
                        }
                    />
                    <TextField
                        value={props.settings.notOnSaleTag}
                        label="Not On Sale Tag"
                        placeholder="(Optional) Example: not-on-sale"
                        onChange={notOnSaleTagChange}
                        helpText={
                            <span>
                                The tag to apply to products that are considered NOT on sale.
                            </span>
                        }
                    />
                    <Checkbox
                        checked={props.settings.priceMustBeLowerThanCompareAtPrice}
                        label="Price must be lower than compare at price"
                        error={props.settingsErrors["priceMustBeLowerThanCompareAtPrice"]}
                        onChange={priceMustBeLowerThanCompareAtPriceChange}
                        helpText={
                            <span>
                                Price must be lower than compare at price for a product to be considered on sale. This would exclude products with compare at price equal to or lower than the current price to be marked as on sale.
                            </span>
                        }
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}